module.exports = __webpack_public_path__ + "img/guide-icon4.10dae789.png";